/**
 * @desc 分页
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<
  defs.tms.IPage<defs.tms.LogisticsProviderTobResponseDto>
>;
export function request(
  params: API.tms.logisticsProviderTob.page.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/logisticsProviderTob/page`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
